angular.module('impactx.address').controller('BasketAddressEditDialogCtrl', [
    '$mdDialog',
    BasketAddressEditDialogController
]);

function BasketAddressEditDialogController($mdDialog) {
    var self = this;

    self.hide = function (answer) {
        $mdDialog.hide(answer);
    };

    self.cancel = function () {
        $mdDialog.cancel();
    };
}